import type { Invitation } from '@fluenceur/types';
import api from '@/libs/axiosInstance';

export const getInvitationMessageDetails = async (conversationId: string): Promise<Invitation> => {
  const response = await api.get(`/dashboard/conversations/${conversationId}/invitation-details`);
  return response.data;
};
